import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
  Animated,
  ActivityIndicator,
} from "react-native";
import { styleSheet } from "app/utils/styleSheet";
import Text from "app/components/Text";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";

import Hoverable from "app/components/Hoverable";
import HoverableTooltip from "app/components/HoverableTooltip";
import { Ionicons, Entypo, MaterialCommunityIcons } from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class ProgressBar extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
    color: PropTypes.string,
    gapless: PropTypes.bool,
  };

  static defaultProps = {
    height: 4,
    // backgroundColor: this.context.colors.highlight
  };

  render() {
    let { value, color, height, gapless, backgroundColor } = this.props;

    let cycle = value.cycle || 7;
    if (!!value.completed_at) {
      cycle = value.progress_at?.length || 1;
    } else {
      cycle = Math.max(cycle, value.progress_at?.length);
    }

    let progressions = [];

    if (gapless) {
      progressions = [value.percent];
    } else {
      progressions = !!value.progress_at?.length
        ? value.progress_at.map((p) => 1)
        : [];

      while (progressions.length < cycle) {
        progressions.push(null);
      }

      if (value.child_ids?.length) {
        let tasks = valueHelpers.getChildren({ value, includeNotes: false });
        if (!!tasks.length) {
          progressions = tasks.map((t) => t.percent);
          progressions = progressions.sort().reverse();
        }
      }
    }
    return (
      <View style={[this.styles().wrapper, { height }]} pointerEvents="none">
        {progressions.map((p, i) => {
          return (
            <View
              key={i}
              style={[
                this.styles().notch,
                {
                  marginRight: i == cycle - 1 ? 0 : 2,
                  // backgroundColor: !!p ? color : undefined,
                  backgroundColor:
                    p === null
                      ? undefined
                      : backgroundColor || this.context.colors.highlight,
                  // opacity: p === 0 ? 0.2 : 1,
                },
              ]}
            >
              {!!p && (
                <View
                  style={[
                    this.styles().notchFill,
                    {
                      backgroundColor: color,
                      right: `${100 - p * 100}%`,
                    },
                  ]}
                />
              )}
            </View>
          );
        })}
      </View>
    );
  }

  styles = () => {
    return {
      wrapper: {
        flex: 1,
        alignSelf: "flex-end",
        flexDirection: "row",
      },
      notch: {
        flex: 1,
        alignSelf: "stretch",
      },
      notchFill: {
        ...StyleSheet.absoluteFillObject,
      },
    };
  };
}
